import React from 'react';
import { Helmet } from 'react-helmet';

import IconSmartGaming from './IconSmartGaming';

const Boot = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Caricamento... - Smart Gaming</title>
      </Helmet>
      <div className="fixed inset-0 h-screen-real w-screen flex flex-col justify-center items-center z-50 bg-gray-100">

        <IconSmartGaming className="mb-1 w-40" />
        <h1 className="font-black font-serif mt-2 text-4xl tracking-tight block text-black">Smart Gaming</h1>
      </div>
    </React.Fragment>
  );
};

export default Boot;